import { IMandateType } from './../../models/user/mandate.model';
import { createReducer, on } from '@ngrx/store';
import { User } from 'src/app/models/user/user.model';
import * as UserActions from '../actions/user.action';
import { Patient } from 'vidis-common';

export interface State {
    user: User;
    ssin: string;
    patient: Patient;
    redirectUrl: string;
    mandateType: IMandateType;
}

const initialState: State = {
    user: undefined,
    ssin: undefined,
    patient: undefined,
    redirectUrl: undefined,
    mandateType: {
        mandateType: undefined,
        code: undefined,
        message: undefined
    },
};

export const userReducer = createReducer(
    initialState,
    on(UserActions.setUserAction, (state, {user}) => ({
        ...state,
        user
    })
    ),

    on(UserActions.setPatientSsinAction, (state, {ssin}) => ({
        ...state,
        patient: {
            ssin
        }
    })),

    on(UserActions.setPatientAction, (state, {patient}) =>
        ({
            ...state,
            patient: {
                ...state.patient,
                lastName: state.patient?.lastName || patient.lastName,
                firstName: state.patient?.firstName || patient.firstName,
                ssin: state.patient?.ssin || patient.ssin
            }
        })
    ),

    on(UserActions.setRedirectUrlAction, (state, {url}) => ({
        ...state,
        redirectUrl: url
    })),

    on(UserActions.setMandateType, (state, {mandateType}) => ({
        ...state,
        mandateType: mandateType
    }))
);
